import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError, BaseResponseEntities } from 'app/shared/reducers/reducer.utils';
import { apiOkr } from 'app/config/axios-interceptor';

const initialState: EntityState<any> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: {},
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/okr/checkin-draft-period';

// Actions

export const getEntities = createAsyncThunk(
  'draftPeriod/fetch_entity_list',
  async ({ searchText, page, size, sort, filters }: IQueryParams) => {
    return apiOkr.get<BaseResponseEntities<any>>(apiUrl, {
      params: {
        searchText,
        page,
        size,
        filters: filters && JSON.stringify(filters),
        sort: sort && sort,
        // cacheBuster: new Date().getTime(),
      },
    });
  },
  { serializeError: serializeAxiosError },
);

export const closeOrOpen = createAsyncThunk(
  'draftPeriod/close_or_open_draftPeriod',
  async (entity: any, thunkAPI) => {
    const result = await apiOkr.put<any>(`${apiUrl}`, cleanEntity(entity));
    return result;
  },
  { serializeError: serializeAxiosError },
);

// slice

export const DraftPeriodSlice = createEntitySlice({
  name: 'draftPeriod',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntities), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          loading: false,
          entities: data.items,
          totalItems: parseInt(data.totalRecord.toString(), 10),
        };
      })
      .addMatcher(isPending(getEntities), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = DraftPeriodSlice.actions;

// Reducer
export default DraftPeriodSlice.reducer;
